

var checkStatus = false;
function openModal() {
  if (!checkStatus) {
    // Get the form element under the 'modal-content-wrapper' container
    var mainEle = document.getElementById("app-embed");

    if (mainEle !== null) {
      // Access the shadow root
      var shadowRoot = mainEle.shadowRoot;
      if (shadowRoot !== null) {
        var appContainer = shadowRoot.getElementById("form-container-ref");

        if (appContainer !== null) {
          // Assuming you have an input element with ID "email"
          var emailInput = appContainer.querySelector("#email");
          var firstName = appContainer.querySelector("#first_name");
          var lastName = appContainer.querySelector("#last_name");

          // Add a keyup event listener
          firstName.addEventListener("keyup", function (event) {
            var sbtBtn = appContainer.querySelector(".bottomElement button");
            var firstNameValue = firstName.value.trim();
            var firstNameLength = firstNameValue.length;

            // Regular expression to match special characters
            var specialCharacterRegex = /[!@#$%^&*(),.?":{}|<>]/;

            // Check if an error message span already exists
            var existingErrorMsg = appContainer.querySelector(".error-msg");
            var existingErrorMsg2 = appContainer.querySelector(".special-error-msg");

            if (firstNameLength < 2 && !existingErrorMsg) {
              var errorMsg = document.createElement("span");
              errorMsg.textContent = "Please enter at least two characters ";
              errorMsg.className = "error-msg"; // Add a class to identify error message spans
              // errorMsg.style.textTransform = 'uppercase';
              errorMsg.style.color = "#e02229";
              errorMsg.style.font = "normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif";
              errorMsg.style.lineHeight = "13px";
              errorMsg.style.marginTop = "10px";

              // Apply box-shadow to the input field
              firstName.style.boxShadow = "0 0 5px 2px red";

              // Append the new error message span to the parent div
              firstName.parentElement.insertAdjacentElement("afterend", errorMsg);
              sbtBtn.disabled = true;
            } else if (firstNameLength >= 2 && existingErrorMsg) {
              // If the first name length is 2 or more, and an error message span exists, remove it
              existingErrorMsg.remove();
              // Remove box-shadow if the error is resolved
              firstName.style.boxShadow = "0 0 0 1px #20202033";
              sbtBtn.disabled = false;
            }

            if (specialCharacterRegex.test(firstNameValue) && !existingErrorMsg2) {
              var errorMsg2 = document.createElement("span");
              errorMsg2.textContent = "This field has an invalid format ";
              errorMsg2.className = "special-error-msg"; // Add a class to identify error message spans
              // errorMsg2.style.textTransform = 'uppercase';
              errorMsg2.style.color = "#e02229";
              errorMsg2.style.font = "normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif";
              errorMsg2.style.lineHeight = "13px";
              errorMsg2.style.marginTop = "10px";

              // Apply box-shadow to the input field
              firstName.style.boxShadow = "0 0 5px 2px red";

              // Append the new error message span to the parent div
              firstName.parentElement.insertAdjacentElement("afterend", errorMsg2);
              sbtBtn.disabled = true;
            } else if (!specialCharacterRegex.test(firstNameValue) && existingErrorMsg2) {
              // If the first name does not contain special characters and an error message span exists, remove it
              existingErrorMsg2.remove();
              // Remove box-shadow if the error is resolved
              firstName.style.boxShadow = "0 0 0 1px #20202033";
              sbtBtn.disabled = false;
            } else if (specialCharacterRegex.test(firstNameValue)) {
              sbtBtn.disabled = true;
            }
          });

          // Add a keyup event listener
          lastName.addEventListener("keyup", function (event) {
            var sbtBtn = appContainer.querySelector(".bottomElement button");
            var lastNameValue = lastName.value.trim();
            var lastNameLength = lastNameValue.length;

            // Regular expression to match special characters
            var specialCharacterRegex = /[!@#$%^&*(),.?":{}|<>]/;

            // Check if an error message span already exists
            var existingErrorMsg = appContainer.querySelector(".last-name-error-msg");
            var existingErrorMsg2 = appContainer.querySelector(".last-name-special-error-msg");

            if (lastNameLength < 2 && !existingErrorMsg) {
              var errorMsg = document.createElement("span");
              errorMsg.textContent = "Please enter at least two characters ";
              errorMsg.className = "last-name-error-msg"; // Add a class to identify error message spans
              // errorMsg.style.textTransform = 'uppercase';
              errorMsg.style.color = "#e02229";
              errorMsg.style.font = "normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif";
              errorMsg.style.lineHeight = "13px";
              errorMsg.style.marginTop = "10px";

              // Apply box-shadow to the input field
              lastName.style.boxShadow = "0 0 5px 2px red";

              // Append the new error message span to the parent div
              lastName.parentElement.insertAdjacentElement("afterend", errorMsg);
              sbtBtn.disabled = true;
            } else if (lastNameLength >= 2 && existingErrorMsg) {
              // If the last name length is 2 or more, and an error message span exists, remove it
              existingErrorMsg.remove();
              // Remove box-shadow if the error is resolved
              lastName.style.boxShadow = "0 0 0 1px #20202033";
              sbtBtn.disabled = false;
            }

            if (specialCharacterRegex.test(lastNameValue) && !existingErrorMsg2) {
              var errorMsg2 = document.createElement("span");
              errorMsg2.textContent = "This field has an invalid format ";
              errorMsg2.className = "last-name-special-error-msg"; // Add a class to identify error message spans
              // errorMsg2.style.textTransform = 'uppercase';
              errorMsg2.style.color = "#e02229";
              errorMsg2.style.font = "normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif";
              errorMsg2.style.lineHeight = "13px";
              errorMsg2.style.marginTop = "10px";

              // Apply box-shadow to the input field
              lastName.style.boxShadow = "0 0 5px 2px red";

              // Append the new error message span to the parent div
              lastName.parentElement.insertAdjacentElement("afterend", errorMsg2);
              sbtBtn.disabled = true;
            } else if (!specialCharacterRegex.test(lastNameValue) && existingErrorMsg2) {
              // If the last name does not contain special characters and an error message span exists, remove it
              existingErrorMsg2.remove();
              // Remove box-shadow if the error is resolved
              lastName.style.boxShadow = "0 0 0 1px #20202033";
              sbtBtn.disabled = false;
            } else if (specialCharacterRegex.test(lastNameValue)) {
              sbtBtn.disabled = true;
            }
          });

          // Create a new label element
          var emailElement = document.createElement("label");
          var firstNameElement = document.createElement("label");
          var lastNameElement = document.createElement("label");

          // Set the 'for' attribute of the label to the ID of the input element
          emailElement.setAttribute("for", "email");
          emailElement.setAttribute("id", "formemail");
          firstNameElement.setAttribute("for", "first_name");
          firstNameElement.setAttribute("id", "firstname");
          lastNameElement.setAttribute("for", "last_name");
          lastNameElement.setAttribute("id", "lastname");

          // Set the text content of the label
          emailElement.textContent = "*EMAIL: ";
          firstNameElement.textContent = "*FIRST NAME:";
          lastNameElement.textContent = "*LAST NAME:";

          // Insert the label before the input element
          if (emailInput !== null || firstName !== null || lastName !== null) {
            emailInput.parentNode.insertBefore(emailElement, emailInput);
            firstName.parentNode.insertBefore(firstNameElement, firstName);
            lastName.parentNode.insertBefore(lastNameElement, lastName);
          }
          const divElements = appContainer.querySelectorAll("form div");

          if (divElements !== null) {
            // Looping through the selected elements and adding a CSS property
            divElements.forEach(function (element) {
              element.style.marginBottom = "0px";
            });
          }

          const inputElements = appContainer.querySelectorAll("form div input");

          if (inputElements !== null) {
            // Looping through the selected elements and adding a CSS property
            inputElements.forEach(function (element) {
              element.style.borderRadius = "0px";
            });
          }

          const inputbutton = appContainer.querySelectorAll("form div button");

          if (inputbutton !== null) {
            // Looping through the selected elements and adding a CSS property
            inputbutton.forEach(function (element) {
              element.style.borderRadius = "0px";
            });
          }

          const genderLabel = appContainer.querySelector("form div:nth-child(2) p");
          const genderBtn = appContainer.querySelector("form div:nth-child(2) button");
          genderBtn.setAttribute("aria-label", "gender-dropdown");
          if (genderLabel !== null) {
            genderLabel.style.font =
              'normal 400 0.688rem "Gothic-720-Bold", "Helvetica Neue", Helvetica, Arial, sans-serif';
            genderLabel.style.lineHeight = "0.813rem";
            genderLabel.style.letterSpacing = "0rem";
            genderLabel.style.marginBottom = "1rem";
            genderLabel.style.textTransform = "uppercase";
          }

          const labelFields = ["#lastname", "#firstname", "#formemail"];
          labelFields.forEach(function (element) {
            const labelEle = appContainer.querySelector("" + element);
            if (labelEle !== null) {
              labelEle.style.font =
                'normal 400 0.688rem "Gothic-720-Bold", "Helvetica Neue", Helvetica, Arial, sans-serif';
              labelEle.style.lineHeight = "0.813rem";
              labelEle.style.letterSpacing = "0rem";
              labelEle.style.marginBottom = "1rem";
              labelEle.style.textTransform = "uppercase";
            }
          });

          const placeHolderFields = ["#label-email", "#label-first_name", "#label-last_name"];
          placeHolderFields.forEach(function (element) {
            const labelEle1 = appContainer.querySelector("" + element);
            if (labelEle1 !== null) {
              labelEle1.style.top = "60%";
              labelEle1.style.textTransform = "uppercase";
              labelEle1.style.color = "#595959";
            }
          });

          const formHeading = appContainer.querySelector("section h2");
          if (formHeading !== null) {
            formHeading.style.font =
              'normal 400 0.688rem "Gothic-720-Bold", "Helvetica Neue", Helvetica, Arial, sans-serif';
            formHeading.style.lineHeight = "0.825rem";
            formHeading.style.letterSpacing = "0rem";
            formHeading.style.marginBottom = "7px";
            formHeading.style.textTransform = "uppercase";
          }

          const formHeading2 = appContainer.querySelector("section p");
          if (formHeading2 !== null) {
            formHeading2.style.font =
              'normal 400 0.688rem "Gothic-720", "Helvetica Neue", Helvetica, Arial, sans-serif';
            formHeading2.style.lineHeight = "0.825rem";
            formHeading2.style.letterSpacing = "-0.01rem;";
            formHeading2.style.marginBottom = "20px";
            formHeading2.style.color = "#B20B14";
            formHeading2.style.textTransform = "uppercase";
          }

          const disclaimerElement = appContainer.querySelector("form").nextElementSibling;
          if (disclaimerElement !== null) {
            disclaimerElement.style.font =
              'normal 400 15px "Gothic-720", "Helvetica Neue", Helvetica, Arial, sans-serif';
            disclaimerElement.style.lineHeight = "1.063rem";
            disclaimerElement.style.letterSpacing = "-0.029rem";
            disclaimerElement.style.textAlign = "left";
            disclaimerElement.style.width = "65%";
          }

          // Get all button elements on the page
          const allButtons = appContainer.querySelectorAll("button");
          // Check if there are any buttons
          if (allButtons.length > 0) {
            // Get the last button
            var lastButton = allButtons[allButtons.length - 1];
            if (lastButton !== null) {
              lastButton.style.width = "35%";
              lastButton.style.font =
                'normal 400 16px "Gothic-720-Bold", "Helvetica Neue", Helvetica, Arial, sans-serif';
              lastButton.style.lineHeight = "22px;";
              lastButton.style.letterSpacing = "0.5px";
              lastButton.style.verticalAlign = "top";
              lastButton.style.background = "#131313";
              lastButton.style.padding = "10px";
              lastButton.style.transform = "uppercase";
              lastButton.style.height = "20px";
              lastButton.style.marginTop = "10px";
              lastButton.style.textTransform = "uppercase";
              lastButton.style.borderRadius = "0px";
            }
          } else {
          }

          // Cut the element and insert it after another element
          const parentForm = disclaimerElement.parentNode;
          if (lastButton !== null) parentForm.removeChild(disclaimerElement);

          // Insert the cut element after the target element
          const parentButton = lastButton.parentNode;
          if (parentButton !== null) parentButton.insertBefore(disclaimerElement, lastButton.nextSibling);

          // Create a new div element
          var newDiv = document.createElement("div");
          newDiv.setAttribute("class", "bottomElement");

          // Append the button and other element to the new div
          newDiv.appendChild(disclaimerElement);
          newDiv.appendChild(lastButton);

          // Append the new div to a specific location (e.g., the body of the document)
          appContainer.querySelector("form").appendChild(newDiv);

          appContainer.querySelector("form .bottomElement").style.display = "flex";
          appContainer.querySelector("form .bottomElement").style.gap = "20px";
          checkStatus = true;
          // Select the form element
          var form = appContainer.querySelector("form");

          // Add an event listener for the submit event
          form.addEventListener("submit", function (event) {
            // Prevent the default form submission behavior
            event.preventDefault();
            var outputElement = form.querySelectorAll('form output[role="alert"]');
            if (outputElement) {
              // Loop through the selected elements
              outputElement.forEach(function (element) {
                // Perform actions on each element
                // element.style.textAlign = "right";
                element.style.paddingBottom = "10px";
                // element.style.fontSize = '14px';
                // element.style.textTransform = 'uppercase';
                element.style.lineHeight = "13px";
                element.style.font = "normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif";
              });
            }
            var submitButtonText = form.querySelector('[data-testid="btn-form-submit"]');
            Shopify.analytics.publish("newsletter_submit", {
              link_text: submitButtonText.textContent.trim(),
              link_classes: event.target.className
            });
          });
        } else {
          return;
        }
      } else {
        return;
      }
    } else {
      return;
    }
  }
  var modal = document.getElementById("myModal");
  if (modal) modal.style.display = "block";
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
  // Get the <span> element that closes the modal
  var newsCloseBtn = document.getElementsByClassName("close")[0];

  if (newsCloseBtn) {
    // When the user clicks on <span> (x), close the modal
    newsCloseBtn.onclick = function () {
      modal.style.display = "none";
    };
  }
}

function closeModal() {
  var modal = document.getElementById("myModal");
  modal.style.display = "none";
}

function validateEmailInput(input) {
  var enteredEmail = input.value.trim();

  if (enteredEmail === "") {
    showError(input, "This field is required.");
  } else {
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var isValidEmail = emailPattern.test(enteredEmail);

    if (isValidEmail) {
      clearError(input);
    } else {
      showError(input, "This field has an invalid format.");
    }
  }
}

function showError(input, message) {
  var errorContainer = document.getElementById("newsletter_email_error");

  if (!errorContainer) {
    errorContainer = document.createElement("div");
    errorContainer.id = "newsletter_email_error";
    input.parentElement.appendChild(errorContainer);
  }

  errorContainer.innerHTML = '<p class="error-message">' + message + "</p>";

  input.classList.add("error-border");
}

function clearError(input) {
  var errorContainer = document.getElementById("newsletter_email_error");

  if (errorContainer) {
    var errorMessage = errorContainer.querySelector(".error-message");
    if (errorMessage) {
      errorMessage.parentElement.removeChild(errorMessage);
    }
  }

  // Remove red border from the input
  input.classList.remove("error-border");
}
